import React from "react";
import { useIntl } from "umi";
import classNames from "classnames";
import { Button } from "tea-component";
import './index.scss';

export interface IConfirmAndCancelProps {
  className?: string;
  bottomPadding?: number;
  cancelLabel?: string;
  preNode?: React.ReactNode;
  nextNode?: React.ReactNode;
  onConfirm?: (value?: any) => void;
  onCancel?: (value?: any) => void;
}

const ConfirmAndCancel = (props: IConfirmAndCancelProps) => {
  const { onConfirm, onCancel, className, bottomPadding = 20, preNode, nextNode, cancelLabel, ...rest } = props;
  const { formatMessage } = useIntl();
  return (<div className={classNames("dbl-confirm-cancel-wrap", className)} style={{paddingBottom: bottomPadding}} {...rest}>
    {preNode}
    <Button
      type="primary"
      onClick={onConfirm}
      className="dbl-confrim"
    >
      {formatMessage({id: 'dbl_common_confirm'})}
    </Button>
    <Button
      onClick={onCancel}
      className="dbl-cancel"
    >
      { cancelLabel ?? formatMessage({id: 'dbl_common_cancel'})}
    </Button>
    {nextNode}
  </div>);
};

export default ConfirmAndCancel;
